export const getBreadCrumb = (area, pref, golfName) => {
  if (!area) {
    return [
      { text: 'ライブカメラ' }
    ]
  } else if (!pref) {
    if (area === 'okinawa') {
      return [
        { text: 'ライブカメラ', link: '../' },
        { text: getPrefectureName(area) }
      ]
    }
    return [
      { text: 'ライブカメラ', link: '../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name }
    ]
  } else if (!golfName) {
    return [
      { text: 'ライブカメラ', link: '../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../' },
      { text: getPrefectureName(pref) }
    ]
  } else {
    return [
      { text: 'ライブカメラ', link: '../../../' },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: '../../' },
      { text: getPrefectureName(pref), link: '../' },
      { text: golfName }
    ]
  }
}
